import { registerIcon } from "@ui5/webcomponents-base/dist/SVGIconRegistry.js";

const name = "decline";
const pathData = "M425.25 109q5 5 5 11.5t-5 11.5l-124 124 124 125q11 11 0 22l-22 23q-12 11-23 0l-125-125-124 125q-5 5-11.5 5t-11.5-5l-22-23q-5-5-5-11t5-11l124-125-124-124q-5-5-5-11.5t5-11.5l22-23q12-11 23 0l124 125 125-125q11-11 23 0l22 23z";

registerIcon(name, { pathData });

export default { pathData };